var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"industry"},[_c('Banner',{attrs:{"bannerContent":_vm.bannerContent}}),_c('ItemWarp',{attrs:{"dataList":_vm.dataList,"loading":_vm.loading,"title":_vm.bannerContent.title},on:{"onScrollBottom":_vm.onScrollBottom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }